import React from 'react'

import * as ACTIONS from 'constant/actions/navigation'
import RequestErrorModal from 'view/component/request-error-modal'

export const navigationShowModal = (content) => ({
  type: ACTIONS.NAVIGATION_SHOW_MODAL,
  modalContent: content
})

export const navigationHideModal = () => ({
  type: ACTIONS.NAVIGATION_HIDE_MODAL
})

export const navigationShowRequestErrorModal = (message) => ({
  type: ACTIONS.NAVIGATION_SHOW_MODAL,
  modalContent: <RequestErrorModal errorMessage={message.toString()} />
})
